import React from 'react';
import HeroSection from '../../HeroSection';
import Pricing from '../../Pricing';


function Projects() {
    return (
        <>
          
          <Pricing />
          

        </>
    )
}

export default Projects;
